import {ICourse} from "../../interfaces/ICourse";
import {AxiosInstance} from "axios";
import {Interceptor} from "../../pages/auth/interceptor";

export default class AugmentedFoodService {

    static listFood = async (): Promise<any[]> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/food`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                let res = await ax.get(url);
                return res.data;
            });
    }

    static listPatients = async (): Promise<ICourse[]> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/patients`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                let res = await ax.get(url);
                return res.data;
            });
    }

    static createPatient = async (data: []): Promise<any> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/patients`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                const res = await ax.post(url, data);
                return res.data;
            });
    }

    static updatePatient = async (id: number, data: []): Promise<any> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/patients/${id}`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                const res = await ax.put(url, data);
                return res.data;
            });
    }

    static listFoodLists = async (): Promise<ICourse[]> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/foodList`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                let res = await ax.get(url);
                return res.data;
            });
    }

    static createFoodList = async (data: []): Promise<any> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/foodList`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                const res = await ax.post(url, data);
                return res.data;
            });
    }

    static deleteFoodList = async (id: number): Promise<any> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/foodList/${id}`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                const res = await ax.delete(url);
                return res.data;
            });
    }

    static listConfigurations = async (): Promise<any[]> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/configurations`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                let res = await ax.get(url);
                return res.data;
            });
    }

    static showConfigurations = async (id): Promise<any> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/configurations/${id}`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                let res = await ax.get(url);
                return res.data;
            });
    }

    static createConfiguration = async (data: any): Promise<any> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/configurations`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                const res = await ax.post(url, data);
                return res.data;
            });
    }

    static deleteConfiguration = async (id: number): Promise<any> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/configurations/${id}`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                const res = await ax.delete(url);
                return res.data;
            });
    }

    static download = async (id: number): Promise<any> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/csv/${id}`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                const res = await ax.get(url, {
                    responseType: 'blob'
                });
                const url_2 = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url_2;
                link.setAttribute('download', `config_${id}_results.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                link.style.display = 'none';
                window.URL.revokeObjectURL(url_2);
                return;
            });
    }

    static downloadHr = async (id: number): Promise<any> => {
        const url = `${process.env["REACT_APP_URL"]}/api/augmentedFood/csv/${id}/hr`;
        return await Interceptor().then(
            async (ax: AxiosInstance) => {
                const res = await ax.get(url, {
                    responseType: 'blob'
                });
                const url_2 = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url_2;
                link.setAttribute('download', `config_${id}_results_hr.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                link.style.display = 'none';
                window.URL.revokeObjectURL(url_2);
                return;
            });
    }
}